<template>
  <div>
    <v-skeleton-loader
      v-if="!noProductFound && !product.upc && !product.paywithpoints"
      class="pb-5"
      type="list-item-avatar, card-heading, image, list-item-two-line,
        button"
    ></v-skeleton-loader>
    <EmptyState v-if="noProductFound">
      <div class="align-center d-flex flex-column">
        <div class="text-center">
          The product you are looking for could not be found.
        </div>
      </div>
    </EmptyState>
    <div v-if="!noProductFound && (product.upc || product.paywithpoints)">
      <AddFromCart v-if="view === 'addFromCart'" :product="cartProduct" />
      <Details v-if="view === 'details' && !rewards" :product="cartProduct" />
      <LoyaltyDetails
        v-if="view === 'details' && rewards"
        :product="cartProduct"
      />
      <Modifiers v-if="view === 'modifiers'" :product="cartProduct" />
    </div>
  </div>
</template>

<script>
import { getProductDetailViewFromProductState } from "@/util.js";
import { mapGetters, mapState } from "vuex";
import AddFromCart from "@/components/Product/XsScreens/AddFromCart.vue";
import Details from "@/components/Product/XsScreens/Details.vue";
import LoyaltyDetails from "@/components/Product/XsScreens/LoyaltyDetails.vue";
import EmptyState from "@/components/EmptyState.vue";
import Modifiers from "@/components/Product/XsScreens/Modifiers.vue";

export default {
  name: "ProductView",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$vuetify.breakpoint.xsOnly) {
        //get view again on return from search
        if (!vm.$store.state.cart.products) return;
        if (!vm.view && vm.product) {
          vm.view = getProductDetailViewFromProductState(vm.product);
        }
        return;
      }
      vm.routeHomeAndOpenProductDialogIfValidUpc(vm);
    });
  },
  components: { AddFromCart, Details, LoyaltyDetails, EmptyState, Modifiers },
  computed: {
    ...mapGetters({
      getProductItemsAndQuantityInCart: "cart/getProductItemsAndQuantityInCart",
    }),
    ...mapState({
      noProductFound: (state) => state.product.noProductFound,
      product: (state) => state.product.details,
    }),
    cartProduct() {
      const itemsAndQuantityFromCart = this.getProductItemsAndQuantityInCart(
        this.product,
      );
      return { ...this.product, ...itemsAndQuantityFromCart };
    },
  },
  created() {
    if (this.$route.name === "rewardProduct") {
      this.rewards = true;
    }
  },
  data() {
    return {
      view: this.$route.params.view || this.$route.query.view,
      rewards: false,
    };
  },
  methods: {
    routeHomeAndOpenProductDialogIfValidUpc(vm) {
      vm.$router.push({
        name: "home",
        params: { upc: vm.$route.params.upc },
      });
    },
  },
  watch: {
    "$route.query.view": function (view) {
      if (!view) {
        this.view = getProductDetailViewFromProductState(this.product);
        return;
      }
      this.view = view;
    },
    "$store.state.cart.products": async function () {
      if (!this.product.upc) {
        if (this.rewards) {
          this.$route.query.points_offer
            ? await this.$store.dispatch("store/setPointsProductbyUpc", {
                offerId: this.$route.query.points_offer,
                upc: this.$route.params.upc,
              })
            : await this.$store.dispatch("store/setClubProductbyUpc", {
                offerId: parseInt(this.$route.query.club_offer),
                upc: this.$route.params.upc,
              });
        } else {
          await this.$store.dispatch(
            "product/getProduct",
            this.$route.params.upc,
          );
        }
      }
      // the cart products are necessary to initialize the product in getProduct
      this.view = getProductDetailViewFromProductState(this.product);
      /*
      if (this.product.upc) {
        return;
      }
      // the cart products are necessary to initialize the product in getProduct
      await this.$store.dispatch("product/getProduct", this.$route.params.upc);
      this.view = getProductDetailViewFromProductState(this.product);
      */
    },
  },
};
</script>
